import React from 'react';
import Title from '../../../../../../@casino/ui/title';
import { useForm } from "react-hook-form";
import clsx from 'clsx';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useDispatch } from 'react-redux';
import { useRouter } from '../../../../../../@casino/useRouter';
import { setPostInvite } from '../../../../../store/invite/thunk/setPostInvite';
import uuidv4 from 'uuid';

const useStyles = makeStyles(() => ({
  helper: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    position: 'relative',
    display: 'inline-block',
    fontSize: '11px',
    color: 'hsla(0,0%,100%,.7)',
    verticalAlign: 'middle',
    fontFamily: "PT Sans, sans-serif",
    userSelect: 'none'
  },
  text: {
    position: 'relative',
    borderRadius: '4px',
    height: '32px',
    overflow: 'hidden',
    boxShadow: '0 1px 0 0 hsl(0deg 0% 100% / 15%), inset 0 1px 0 0 rgb(0 0 0 / 15%)',
    border: 0,
    background: '#1c2542',
    color: '#fff',
    outline: 'none',
    paddingLeft: 8,
  },
  wrapLabel: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 12,
  },
  beginBonusLabel: {
    width: '32%',
  },
}))

const AffiliateInviteCreate = () => {
  const dispatch = useDispatch();
  const router = useRouter();
  const classes = useStyles();
  const uuid_rand = uuidv4().replaceAll("-", "")

  const { handleSubmit, register, setValue } = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues: {
    }
  });

  const onSubmit = (store) => {
    dispatch(setPostInvite(store, () => {
      router.history.push('/affiliate/invite_affilates/list')
    }))
  }

  return (
    <div style={{
      padding: '0 20px'
    }}>
      <Title
        label="Создание Инвайта"
        labelBtn="Назад"
        handleClick={() => router.history.push('/affiliate/invite_affilates/list')}
      />
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        padding: 20,
        background: '#1b2039',
        borderRadius: 8,
      }}>
        <form onSubmit={handleSubmit(onSubmit)} style={{ display: 'flex', flexDirection: 'column' }}>
          <div style={{ display: 'flex', columnGap: 12, alignItems: 'flex-end' }}>
            <label htmlFor="code" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
              <span className={classes.helper}>Код</span>
              <input
                {...register('code')}
                type="text"
                id="code"
                placeholder='Введите code'
                className={classes.text}
              />
            </label>
            <div>
              <button 
                type="button" 
                onClick={() => {
                  setValue("code", uuid_rand)
                }}
                style={{
                  color: '#141b33',
                  cursor: 'pointer',
                  padding: '10px',
                  background: '#ffc324',
                  borderRadius: '4px',
                  border: 'none',
                  outline: 'none'
                }}
                >
                  Сгенерировать
                </button>
            </div>
          </div>
          
          <label htmlFor="url" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
            <span className={classes.helper}>URL</span>
            <input
              {...register('url')}
              type="text"
              id="url"
              placeholder='Введите url'
              className={classes.text}
            />
          </label>

          <div style={{ marginTop: 12 }}>
            <button
              type="submit"
              style={{
                color: '#141b33',
                cursor: 'pointer',
                padding: '10px',
                background: '#ffc324',
                borderRadius: '4px',
                border: 'none',
                outline: 'none'
              }}
            >
              Сохранить
            </button>
          </div>

        </form>
      </div>
    </div>
  )
}

export default AffiliateInviteCreate;